export default {
  pdf: true,
  mp4: true,
  jpg: true,
  mov: true,
  png: true,
  jpeg: true
}


// WEBPACK FOOTER //
// ./src/utils/previewable.ts